const $inject = ['$location', 'dataService'];

const lbaBreadCrumbCtrl = function ($location, dataService) {
  const vm = this;
  const pathArray = $location.path().split('/');
  vm.dataService = dataService;
  pathArray.shift();

  vm.pathArray = [];

  pathArray.forEach(path => {
    const lastItem = _.last(vm.pathArray);

    if (lastItem) {
      vm.pathArray.push({
        url: lastItem.url + '/' + path,
        name: path
      });
    } else {
      vm.pathArray.push({
        url: path,
        name: path
      });
    }

  });
};

lbaBreadCrumbCtrl.$inject = $inject;

export default lbaBreadCrumbCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaBreadCrumb/lbaBreadCrumbCtrl.js